import { toCtaData } from "@/contents/converters/atoms"
import BlokWrapper from "@/contents/integrations/BlokWrapper"
import SanityImageField from "@/integrations/sanity/components/SanityImageField"
import SanityRichTextField from "@/integrations/sanity/components/SanityRichTextField"
import Hero2 from "@/ui/organisms/Hero2"
import { CtaData } from "@/ui/types/cta"
import { setCssVar, ThemeColor } from "@punks/ui-core"
import { Hero2 as Hero2Type } from "@/contents/sanityTypes"
import { SanityDecoration } from "@/contents/molecules/SanityDecoration"

export interface SanityHero2Props {
  content: Hero2Type
}

const Sanity2Hero = ({ content }: SanityHero2Props) => {
  return (
    <BlokWrapper
      contents={content}
      style={{
        ...setCssVar("--bg-position", content.backgroundPositionXs ?? "center"),
        ...setCssVar(
          "--bg-position-desktop",
          content.backgroundPositionSm ?? "center"
        ),
      }}
      className="overflow-hidden"
      menuColor="textNegative"
    >
      <Hero2
        text={<SanityRichTextField value={content.text} />}
        backgroundColor={content.backgroundColor as ThemeColor}
        background={{
          image: content.backgroundImage?.asset ? (
            <SanityImageField
              asset={content.backgroundImage.asset}
              responsive
              objectFit="contain"
              height="100%"
              className="scale-[110%] object-[var(--bg-position)] sm:object-[var(--bg-position-desktop)]"
            />
          ) : undefined,
        }}
        height={content.height}
        textColor={content.textColor as ThemeColor}
        cta={content.cta
          ?.map((x: any) => toCtaData(x) as CtaData)
          .filter((x: any) => x)}
        alignment={content.alignment ? content.alignment : undefined}
        decorations={
          content.decoration?.image?.asset
            ? [
                <SanityDecoration
                  key={0}
                  asset={content.decoration.image.asset}
                  position={content.decoration.position ?? {}}
                  size={content.decoration.size ?? {}}
                  absolute
                />,
              ]
            : []
        }
      />
    </BlokWrapper>
  )
}

export default Sanity2Hero
